<template>
  <div v-if="currentRouteName" ref="scrollRef" class="scroll-container-home" @scroll="handleScroll">
    <slot></slot>
  </div>

  <div v-else ref="scrollRef" class="scroll-container" @scroll="handleScroll">
    <slot></slot>
  </div>
</template>
<script>

/**
 * Emits event if scrolling action on the tracked elements reached to the top, bottom and scrolling
 * You can define on the children of the slot to track on using trackAttribute
 * By default it tracks all the children
 */
function debounce(func, delay) {
  let timeoutId;

  return function () {
    const context = this;
    const args = arguments;

    clearTimeout(timeoutId);

    timeoutId = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
}

export default {
  props: {
    trackAttribute: {
      type: String,
      default: 'track-scroll', // Default attribute name
    },
    bottomThreshold: {
      type: Number,
      default: 100, // In percentage of scroll container
    },
    topThreshold: {
      type: Number,
      default: 5, // In percentage of scroll container
    },
    delayMs: {
      type: Number,
      default: 10, // in milliseconds
    }
  },
  data() {
    return {
      topmostElement: null,
      bottommostElement: null,
    };
  },

  computed: {
    currentRouteName() {
      return this.$route.path === '/home';
    }
  },
  mounted() {
    this.precomputeTrackedElements();
  },
  methods: {
    handleScroll: debounce(function () {
      const scrollLayer = this.$refs.scrollRef;
      const topRefLine = scrollLayer.getBoundingClientRect().top;
      const bottomRefLine = scrollLayer.getBoundingClientRect().bottom;
      const bottomGap = Math.max(0, this.bottomThreshold) * Math.abs(topRefLine - bottomRefLine) / 100;
      const topGap = Math.max(0, this.topThreshold) * Math.abs(topRefLine - bottomRefLine) / 100;

      // Emit events based on the precomputed topmost and bottommost tracked elements
      if (this.topmostElement) {
        const topDistance =  topRefLine - this.topmostElement.getBoundingClientRect().top;

        if (topDistance < topGap) {
          // console.log("Topmost tracked element reached top");
          this.$emit('onTop');
        }
      }

      if (this.bottommostElement) {
        const bottomDistance = bottomRefLine - this.bottommostElement.getBoundingClientRect().bottom;

        if (bottomDistance > -bottomGap) {
          // console.log("Bottommost tracked element reached bottom");
          this.$emit('onBottom');
        }
      }
      this.$emit('onScrolling');
    }, 10), // Set the desired throttle time in milliseconds
    precomputeTrackedElements() {
      const scrollLayer = this.$refs.scrollRef;
      const children = scrollLayer.children;

      for (let i = 0; i < children.length; i++) {
        const element = children[i];
        const shouldTrack = element.hasAttribute(this.trackAttribute);

        if (shouldTrack) {

          // Update topmost and bottommost tracked elements
          if (!this.topmostElement || element.getBoundingClientRect().top < this.topmostElement.getBoundingClientRect().top) {
            this.topmostElement = element;
          }

          if (!this.bottommostElement || element.getBoundingClientRect().bottom > this.bottommostElement.getBoundingClientRect().bottom) {
            this.bottommostElement = element;
          }
        }
      }

      if (!this.topmostElement && !this.bottommostElement && children.length) {
        this.topmostElement = children[0];
        this.bottommostElement = children[children.length - 1];
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.scroll-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scroll-container-home {
  position: relative;
  width: 100%;
  height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}
</style>